import * as React from 'react';
import { SVGProps } from 'react';

const IconLockSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4V3a2 2 0 1 1 4 0v1h1.47a.53.53 0 0 1 .53.53v5.94a.53.53 0 0 1-.53.53H2.53a.53.53 0 0 1-.53-.53V4.53A.53.53 0 0 1 2.53 4H4Zm1-1a1 1 0 0 1 2 0v1H5V3Zm2.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    />
  </svg>
);
export default IconLockSizeXs;
